import React from 'react';
import PropTypes from 'prop-types';

import { processContactData } from '../../utils/DrupalEntityTypes/Community/CommunityHelpers';
import { createSkeletonItem } from '../Skeleton/SkeletonHelpers';

import '../Skeleton/Skeleton.scss';

const CommunityContact = ({
  className,
  pre,
  post,
  residentCommunityData,
}) => {
  const {
    community,
    salesCounselor,
  } = residentCommunityData || {};

  const {
    phone,
    email,
    name,
  } = processContactData(community, salesCounselor) || {};

  return (
    <div className={`${className || ''}`}>

      {createSkeletonItem('span', null, 'full', !residentCommunityData)}

      { name && (
        <span>
          {pre}
          {name}
          {email && (
            <>
              {' '}
              at
              {' '}
              <a href={`mailto:${email}`}>{email}</a>
            </>
          )}
        </span>
      )}

      {phone && (
        <span>
          {email ? <> or </> : <> at </>}
          {phone}
          {' '}
          {post}
        </span>
      )}

    </div>
  );
};

CommunityContact.propTypes = {
  className: PropTypes.string,
  pre: PropTypes.string,
  post: PropTypes.string,
  residentCommunityData: PropTypes.shape({
    community: PropTypes.shape({
      email: PropTypes.string,
      phone: PropTypes.string,
    }),
    salesCounselor: PropTypes.shape({
      mail: PropTypes.string,
      email: PropTypes.string,
      fieldPhone: PropTypes.string,
      phone: PropTypes.string,
      fieldFirstName: PropTypes.string,
      firstName: PropTypes.string,
      fieldLastName: PropTypes.string,
      lastName: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
};

CommunityContact.defaultProps = {
  className: null,
  pre: 'Contact ',
  post: ' if you have questions.',
  residentCommunityData: null,
};

export default CommunityContact;
